import {Component, Inject, OnInit} from '@angular/core';
import {Ofwca} from '../../../shared/interface/ofwca';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface KrkAddDialogData {
  ofwcaObject: Ofwca;
}

@Component({
  selector: 'app-krk-add-dialog',
  templateUrl: './krk-add-dialog.component.html',
  styleUrls: ['./krk-add-dialog.component.scss']
})
export class KrkAddDialogComponent implements OnInit {
  ofwcaObject?: Ofwca = null;

  constructor(
    public dialogRef: MatDialogRef<KrkAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: KrkAddDialogData,
  ) {
    this.ofwcaObject = data.ofwcaObject;
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
